export default __webpack_public_path__ + "static/media/andriolegroup-logo.ee7a55c8.png";